<template>
  <Grid gaf="column" justify-content="space-between" align-items="start">
    <Grid gap="var(--r-space-sm)" class="text-secondary-3">
      <div class="text-heading-3">Renewal proposal table</div>
      <div class="text-body-1">Make a decision regarding the renewal process of subscriptions.</div>
    </Grid>

    <Grid gap="var(--r-space-md)" justify-items="end" class="text-right">
      <Grid gap="var(--r-space-md)" class="actions">
        <div class="text-secondary-5 text-body-1">
          Set proposal for
          <span class="text-heading-3">{{ numberOfSelectedRows }}</span>
          selected {{ numberOfSelectedRows === 1 ? 'subscription' : 'subscriptions' }}:
        </div>
        <Grid gaf="column" gap="var(--r-space-sm)" class="buttons">
          <SpecialBtn
            v-for="status of statuses"
            :key="status.id"
            v-bind="specialButtonState"
            :type="status.name.replace('to accept', 'to renew')"
            :style="{ '--width': btnWidth(status.name) }"
            @click="$emit('open-dialog', { status: { ...status }, numberOfSelectedRows })"
          >
            {{ status.name.toUpperCase() }}
          </SpecialBtn>
        </Grid>
      </Grid>
      <ShowHideCols :ag-grid="agGrid" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState, mapGetters } from 'vuex'
// Components
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import SpecialBtn from '@/ui/SpecialBtn'

export default {
  components: {
    ShowHideCols,
    SpecialBtn
  },

  props: {
    agGrid: { required: true }
  },

  computed: {
    ...mapState('renewal-proposal', ['selectAll', 'rowsSelected', 'totalRows', 'statuses']),
    ...mapGetters('renewal-proposal', ['numberOfSelectedRows']),

    specialButtonState() {
      const state = { disable: false, active: false }

      if (!this.numberOfSelectedRows) state.disable = true
      else state.active = true

      return state
    },

    btnWidth() {
      return btnType => {
        const map = {
          'to accept': '70px',
          undecided: '66px',
          'to cancel': '71px'
        }

        return map[btnType]
      }
    }
  }
}
</script>
